module.exports = __webpack_public_path__ + "static/media/quantu.76215e5d.jpg";